module.exports = __webpack_public_path__ + "img/close-white.db4bb9bb.svg";